import _tableSortingHandler from '@/components/Commons/_mixins/_tableSortingHandler'
export default {
  mixins: [_tableSortingHandler],
  methods: {
    async sortByField (fieldName) {
      await this.$store.dispatch('TransactionsStore/sortTransactionsByField', { fieldName })
    }
  },
  computed: {
    currentFilters () {
      return this.$store.getters['TransactionsStore/filters']
    }
  }
}
